<template>
  <v-container>
    <v-toolbar flat color="white">
        <v-menu
          :close-on-content-click="true"
          v-model="mStartDate"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px">
          <template v-slot:activator="{attrs, on}">
            <v-text-field v-bind="attrs" v-on="on" v-model="dStart" label="开始日期" clearable prepend-icon="event" readonly></v-text-field>
          </template>
          <v-date-picker v-model="dStart" locale="zh-cn"></v-date-picker>
        </v-menu>
        <v-menu
          :close-on-content-click="true"
          v-model="mEndDate"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px">
          <template v-slot:activator="{attrs, on}">
            <v-text-field v-bind="attrs" v-on="on" v-model="dEnd" label="结束日期" clearable prepend-icon="event" readonly></v-text-field>
          </template>
          <v-date-picker v-model="dEnd" locale="zh-cn"></v-date-picker>
        </v-menu>
        <v-text-field
          v-model="search_str"
          label="搜索"
          prepend-icon="search"
          clearable
          >
        </v-text-field>
        <v-btn @click="reload" small color="success" style="margin-left:10px;"><v-icon>search</v-icon>搜索</v-btn>
        <v-btn @click="toexcel" small color="info" style="margin-left:10px;"><v-icon>list_alt</v-icon>导出xlsx</v-btn>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
    </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="items"
        :server-items-length="pagination.totalItems"
        :loading="loading"
        hide-default-footer
        class="elevation-1">
        <template v-slot:item.act="{item}">
          <v-tooltip bottom>
            <template v-slot:activator="{attrs, on}">
              <v-btn v-bind="attrs" v-on="on" small icon @click="Print(item)" color="success"><v-icon>print</v-icon></v-btn>
            </template>
            <span>打印</span>
          </v-tooltip>
          <v-tooltip bottom v-if="canDelSo">
            <template v-slot:activator="{attrs, on}">
              <v-btn v-bind="attrs" v-on="on" small icon @click="deleSo(item)" color="error"><v-icon>delete</v-icon></v-btn>
            </template>
            <span>删除</span>
          </v-tooltip>
        </template>
        <template slot="no-data">
          没有数据
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination v-model="pagination.page" :length="pagination.totalPages"></v-pagination>
      </div>

      <v-dialog v-model="dlgStockOut" max-width="900px">
        <v-card>
          <vue-easy-print tableShow ref="soPrint">
            <stock-out :tableData="soData"></stock-out>
          </vue-easy-print>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dlgStockOut=false">取消</v-btn>
            <v-btn color="success" @click="doPrint"><v-icon>print</v-icon>打印</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-container>
</template>

<style>
</style>

<script>
import vueEasyPrint from 'vue-easy-print'
import StockOut from './StockOut'
import { getStockOutList, getStockOutItemList, deleteStockOut } from '@/api/stockout'
import { Date2Int, Int2Date } from '@/libs/util'
import { baseURLAPI, TOKEN_KEY } from '@/config'
import Cookies from 'js-cookie'
import { canDo } from '@/libs/tools'

export default {
  components: {
    vueEasyPrint,
    StockOut
  },
  data: () => ({
    dlgStockOut: false,
    mStartDate: false,
    mEndDate: false,
    dStart: '',
    dEnd: '',
    search_str: '',
    loading: false,
    items: [],
    pagination: {
      page: 1,
      sortBy: '',
      descending: false,
      rowsPerPage: 10,
      totalItems: 0,
      totalPages: 0
    },
    headers: [
      { text: '日期', value: 'dt', sortable: false },
      { text: '出库单号', value: 'no', sortable: false },
      { text: '客户', value: 'customer_title', sortable: false },
      { text: '操作', value: 'act', sortable: false }
    ],
    soData: {
      soNo: '',
      customer_name: '',
      customer_address: '',
      customer_contact: '',
      customer_phone: '',
      date: '2018-12-20',
      items: []
    }
  }),
  computed: {
    canDelSo () {
      return canDo(['admin', 'del_stockout'], this.$store.state.user.access)
    }
  },
  methods: {
    doDele (id) {
      deleteStockOut(id).then(res => {
        this.reload()
      })
    },
    deleSo (item) {
      this.$swal.fire({
        title: '警告',
        text: '确实要删除码?',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then((result) => {
        if (result.isConfirmed) {
          this.doDele(item.id);
        }
      })
    },
    toexcel () {
      let start = Date2Int(this.dStart)
      let end = Date2Int(this.dEnd)
      let kw = this.search_str === undefined ? '' : this.search_str
      let token = Cookies.get(TOKEN_KEY)
      var w = window.open('', '_blank')
      let url = baseURLAPI + 'stockout/toexcel'
      w.document.write(`<html><head>
                          <script>
                            function ff() {
                              this.form.submit();
                            }
                          <\/script>
                        </head><body>
                        <form name="form" method="post" action="` + url + `">
        <input type="hidden" name="start" value="` + start + `" />
        <input type="hidden" name="end" value="` + end + `" />
        <input type="hidden" name="kw" value="` + kw + `" />
        <input type="hidden" name="token" value="` + token + `" />
        </form></body></html>`
      )
      w.ff()
    },
    Print (e) {
      this.soData.soNo = e.sono
      this.soData.customer_name = e.customer_title
      this.soData.customer_address = e.customer_address
      this.soData.customer_contact = e.customer_contact
      this.soData.customer_phone = e.customer_phone
      this.soData.date = e.date
      getStockOutItemList(e.id).then(res => {
        this.soData.items = res.data
        for (var i = 0; i < this.soData.items.length; ++i) {
          var e = this.soData.items[i]
          e.no = i + 1
          e.unit = 'kg'
        }
      })
      this.dlgStockOut = true
    },
    doPrint () {
      this.$refs.soPrint.print()
    },
    reload () {
      let d = {
        'start': Date2Int(this.dStart),
        'end': Date2Int(this.dEnd),
        'kw': this.search_str,
        'page': this.pagination.page,
        'perPage': this.pagination.rowsPerPage
      }
      this.loading = true
      getStockOutList(d).then(res => {
        this.items = res.data.items
        this.items.forEach(e => {
          e.date = Int2Date(e.dt)
          e.sono = e.dt.toString().substr(2) + e.no.toString().padStart(3, '0')
        })
        if (res.data._meta.page > res.data._meta.total_pages) {
          this.pagination.page = res.data._meta.total_pages
        } else {
          this.pagination.page = res.data._meta.page
        }
        this.pagination.totalPages = res.data._meta.total_pages
        this.pagination.totalItems = res.data._meta.total_items
        this.loading = false
      })
    }
  },
  watch: {
    pagination: {
      handler () {
        this.reload()
      },
      deep: true
    }
  },
  mounted () {
    this.reload()
  }
}
</script>
